(function () {
  const configElement = document.getElementById('MysteryGiftConfig');
  const popup = document.querySelector('[data-mystery-gift-popup]');

  if (!configElement || !popup || !window.routes) return;

  let config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Mystery gift config is invalid.', error);
    return;
  }

  function parseVariantId(value) {
    const rawValue = String(value || '').trim();
    if (!rawValue) return '';

    const variantPatterns = [
      /ProductVariant\/(\d+)/i,
      /\/variants\/(\d+)/i,
      /[?&]variant=(\d+)/i,
    ];

    for (const pattern of variantPatterns) {
      const match = rawValue.match(pattern);
      if (match) return match[1];
    }

    return /^\d+$/.test(rawValue) ? rawValue : '';
  }

  const tiers = (config.tiers || [])
    .map((tier) => ({
      ...tier,
      variantId: parseVariantId(tier.variantId),
    }))
    .filter((tier) => tier.variantId && tier.threshold)
    .sort((a, b) => a.threshold - b.threshold);

  if (!config.enabled || tiers.length === 0) return;

  const giftVariantIds = new Set(tiers.map((tier) => String(tier.variantId)));
  const declineStorageKey = 'vlMysteryGiftDeclined';
  const giftTierProperty = '_mystery_gift_tier';
  const acceptButton = popup.querySelector('[data-mystery-gift-accept]');
  const declineButtons = popup.querySelectorAll('[data-mystery-gift-decline]');
  const messageElement = popup.querySelector('[data-mystery-gift-message]');
  const errorElement = popup.querySelector('[data-mystery-gift-error]');
  const termsCheckbox = popup.querySelector('[data-mystery-gift-terms]');
  const dialog = popup.querySelector('[role="dialog"]');

  let activeTier = null;
  let activeElement = null;
  let isProcessing = false;
  let isEvaluating = false;
  let evaluationQueued = false;

  function getStoredDecline() {
    try {
      return sessionStorage.getItem(declineStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function storeDecline() {
    try {
      sessionStorage.setItem(declineStorageKey, 'true');
    } catch (error) {
      return;
    }
  }

  function clearDecline() {
    try {
      sessionStorage.removeItem(declineStorageKey);
    } catch (error) {
      return;
    }
  }

  function getGiftItems(cart) {
    return (cart.items || []).filter((item) => giftVariantIds.has(String(item.variant_id)));
  }

  function getQualifyingSubtotal(cart) {
    return (cart.items || []).reduce((subtotal, item) => {
      if (giftVariantIds.has(String(item.variant_id))) return subtotal;
      return subtotal + (item.final_line_price ?? item.line_price ?? item.original_line_price ?? 0);
    }, 0);
  }

  function getEligibleTier(cart) {
    const subtotal = getQualifyingSubtotal(cart);
    return tiers.reduce((eligibleTier, tier) => {
      if (subtotal >= tier.threshold) return tier;
      return eligibleTier;
    }, null);
  }

  function setButtonsLoading(isLoading) {
    isProcessing = isLoading;
    if (acceptButton) acceptButton.disabled = isLoading;

    if (window.cartButtonManager) {
      if (isLoading) {
        window.cartButtonManager.disableAllButtons();
      } else {
        window.cartButtonManager.enableAllButtons();
      }
    }
  }

  function setError(message) {
    if (!errorElement) return;
    errorElement.textContent = message || '';
    errorElement.hidden = !message;
  }

  function showPopup(tier) {
    activeTier = tier;
    setError('');

    if (messageElement) {
      messageElement.textContent = `Your cart has reached ${tier.spend}, so you qualify for a free Mystery Box worth ${tier.value}.`;
    }

    if (!popup.hidden) return;

    activeElement = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('mystery-gift-popup-open');

    if (termsCheckbox) {
      termsCheckbox.checked = false;
    }

    if (typeof trapFocus === 'function' && dialog) {
      trapFocus(dialog, termsCheckbox || acceptButton || dialog);
    } else if (acceptButton) {
      acceptButton.focus();
    }
  }

  function closePopup() {
    if (popup.hidden) return;
    popup.hidden = true;
    activeTier = null;
    document.body.classList.remove('mystery-gift-popup-open');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(activeElement);
    } else if (activeElement && typeof activeElement.focus === 'function') {
      activeElement.focus();
    }
  }

  function getSectionsToRender() {
    const sections = new Set(['cart-icon-bubble']);
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach((section) => sections.add(section.id));
    }

    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems?.dataset.id) sections.add(mainCartItems.dataset.id);
    if (mainCartFooter?.dataset.id) sections.add(mainCartFooter.dataset.id);
    if (document.getElementById('cart-live-region-text')) sections.add('cart-live-region-text');

    return Array.from(sections);
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  function replaceSection(target, html, selector) {
    if (!target || !html) return;
    const content = getSectionInnerHTML(html, selector);
    if (content !== undefined) target.innerHTML = content;
  }

  function renderSections(response) {
    if (!response?.sections) return;

    replaceSection(document.getElementById('CartDrawer'), response.sections['cart-drawer'], '#CartDrawer');
    replaceSection(document.getElementById('cart-icon-bubble'), response.sections['cart-icon-bubble'], '.shopify-section');

    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems?.dataset.id) {
      replaceSection(mainCartItems.querySelector('.js-contents') || mainCartItems, response.sections[mainCartItems.dataset.id], '.js-contents');
    }

    if (mainCartFooter?.dataset.id) {
      replaceSection(mainCartFooter.querySelector('.js-contents') || mainCartFooter, response.sections[mainCartFooter.dataset.id], '.js-contents');
    }
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mystery-gift', cartData });
    }
  }

  async function requestCart(endpoint, body) {
    const response = await fetch(endpoint, {
      ...fetchConfig(),
      body: JSON.stringify({
        ...body,
        sections: getSectionsToRender(),
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      const error = new Error(data.description || data.message || 'The cart could not be updated.');
      error.status = response.status || data.status;
      throw error;
    }

    renderSections(data);
    publishCartUpdate(data);
    return data;
  }

  function getGiftUpdates(cart, tier) {
    const updates = {};
    const giftItems = getGiftItems(cart);
    let hasCorrectGift = false;

    giftItems.forEach((item) => {
      if (tier && String(item.variant_id) === tier.variantId && !hasCorrectGift) {
        hasCorrectGift = true;
        if (item.quantity !== 1) updates[item.key] = 1;
      } else {
        updates[item.key] = 0;
      }
    });

    return { updates, hasCorrectGift };
  }

  async function addGift(tier) {
    return requestCart(routes.cart_add_url, {
      id: tier.variantId,
      quantity: 1,
      properties: {
        [giftTierProperty]: tier.id,
      },
    });
  }

  async function syncGiftItems(cart, tier) {
    const giftItems = getGiftItems(cart);

    if (giftItems.length === 0) return false;

    const { updates, hasCorrectGift } = getGiftUpdates(cart, tier);

    if (Object.keys(updates).length > 0) {
      await requestCart(routes.cart_update_url, { updates });
    }

    if (tier && !hasCorrectGift) {
      await addGift(tier);
    }

    return Object.keys(updates).length > 0 || (tier && !hasCorrectGift);
  }

  async function fetchCart() {
    const response = await fetch(`${routes.cart_url}.js`);
    if (!response.ok) throw new Error('The cart could not be loaded.');
    return response.json();
  }

  async function evaluateCart() {
    if (isProcessing) {
      evaluationQueued = true;
      return;
    }

    if (isEvaluating) {
      evaluationQueued = true;
      return;
    }

    isEvaluating = true;

    try {
      const cart = await fetchCart();
      const tier = getEligibleTier(cart);
      const giftItemsChanged = await syncGiftItems(cart, tier);

      if (giftItemsChanged) {
        closePopup();
        return;
      }

      if (!tier || getGiftItems(cart).length > 0 || getStoredDecline()) {
        closePopup();
        return;
      }

      showPopup(tier);
    } catch (error) {
      console.error('Mystery gift check failed.', error);
    } finally {
      isEvaluating = false;

      if (evaluationQueued) {
        evaluationQueued = false;
        window.setTimeout(evaluateCart, 100);
      }
    }
  }

  async function handleAccept() {
    if (!activeTier || isProcessing) return;

    if (termsCheckbox && !termsCheckbox.checked) {
      setError('Please confirm that you understand the mystery box items may be short dated, expired, or supplied as singles before adding the gift.');
      termsCheckbox.focus();
      return;
    }

    setButtonsLoading(true);
    setError('');
    let selectedTier = activeTier;

    try {
      const cart = await fetchCart();
      selectedTier = getEligibleTier(cart);

      if (!selectedTier) {
        closePopup();
        return;
      }

      const { updates, hasCorrectGift } = getGiftUpdates(cart, selectedTier);

      if (Object.keys(updates).length > 0) {
        await requestCart(routes.cart_update_url, { updates });
      }

      if (!hasCorrectGift) {
        await addGift(selectedTier);
      }
      clearDecline();
      closePopup();
    } catch (error) {
      console.error('Mystery gift add failed.', {
        tier: selectedTier?.id,
        variantId: selectedTier?.variantId,
        error,
      });

      if (error.status === 422 || /variant/i.test(error.message || '')) {
        setError(`This gift variant could not be added. Please check the ${selectedTier?.label || 'mystery gift'} variant ID in theme settings and make sure the variant is active, in stock, and available to this customer on the Online Store sales channel.`);
      } else {
        setError(error.message || 'Sorry, we could not add your free gift. Please try again.');
      }
    } finally {
      setButtonsLoading(false);
      window.setTimeout(evaluateCart, 100);
    }
  }

  function handleDecline() {
    storeDecline();
    closePopup();
  }

  acceptButton?.addEventListener('click', handleAccept);
  declineButtons.forEach((button) => button.addEventListener('click', handleDecline));

  popup.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') handleDecline();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'mystery-gift') return;
      window.setTimeout(evaluateCart, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluateCart);
  } else {
    evaluateCart();
  }
})();
